import { fetchCachedHelper } from '../../../api/api'
import { courseDetailsActions } from './courseDetailsSlice'

export const getCourse = id => async dispatch => {
    dispatch(courseDetailsActions.getCourseDetailsRequest())
    try {
        const [courseRes, relatedCourses] = await Promise.all([
            fetchCachedHelper(`Course/${id}`),
            getRelatedCourses(id),
        ])

        const courseDetails = {
            ...courseRes.data,
            relatedCourses,
        }
        dispatch(
            courseDetailsActions.getCourseDetailsRequestSuccess(courseDetails)
        )
    } catch (e) {
        dispatch(courseDetailsActions.getCourseDetailsRequestError(e.message))
    }
}

export const getRelatedCourses = async id => {
    let { data: relatedCourses } = await fetchCachedHelper(
        `Course/GetRelatedCoursesByID/${id}`
    )
    return relatedCourses
}
